import { Navigate, useParams } from "react-router";
import { useLegacyVersionTarget } from "~/api/swr/useLegacyVersionTarget";
import { CenterSpinner } from "~/atoms/spinner";

const LegacyVersionResolverPage = () => {
  const { id } = useParams();

  const { data, isLoading } = useLegacyVersionTarget(id);

  if (isLoading) {
    return <CenterSpinner />;
  }

  if (!data) {
    return <Navigate to="/documents" replace />;
  }

  return (
    <Navigate
      to={`/documents/${data.documentId}?releaseId=${data.releaseId}`}
      replace
    />
  );
};

export default LegacyVersionResolverPage;
